import React from 'react'
import Slider from 'react-slick'
import {Link} from 'react-router-dom'
import { connect } from 'react-redux'
import { useEffect } from 'react'
import { fetchPrizesIfNeeded } from '~/features/actions'
import { DateTime } from 'luxon'

const month = ["January","February","March","April","May","June","July","August","September","October","November","December"];

const d = new Date();


const Prizes = (props) => {
	useEffect( () => { props.dispatch( fetchPrizesIfNeeded(props.category) ) } , []);
	const settings = {
		dots: false,
		arrows: true,
		infinite: true,
		speed: 100,
		slidesToScroll: 1,
		fade: false,
		cssEase: 'linear',
		autoplay: true,
		autoplaySpeed: 2500,
		responsive: [
			{
				breakpoint: 3000,
				settings: {
					slidesToShow: 3,
					arrows: false
				}
			},
			{
				breakpoint: 1440,
				settings: {
					slidesToShow: 3,
					arrows: false
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
					arrows: false
				}
			}
		]
	}

	if(props.prizes.items.length > 0) {
		if ( props.variant === 'monthly') { 
			return (
				<div className="margin prizes-list">
					<h2>{ month[d.getMonth()] + ' Prize' }</h2>
					{props.prizes.items.filter(i => (i.created === DateTime.local().setZone("Australia/Brisbane").toFormat('yyyy-MM') && i.prize_category === 'Monthly Subscriber Prize')  ).map( ( item, index) =>
							<div className="prize" key={index}>
								<div style={{ flex: 'none' }}>
									<div>
										<img src={'//jeff.4zzz.org.au/' + item.field_image.split(',')[0] }  style={{maxWidth: '100%', float: 'left'}} />
									</div>
								</div>
								<div>
									<h3>{item.title}</h3>
									<div dangerouslySetInnerHTML={{ __html: item.body_1 }}></div>
								</div>
							</div>
						) }

						<h3>Last months prize</h3>
						{props.prizes.items.filter(i => (i.created === DateTime.local().setZone("Australia/Brisbane").minus({months: 1}).toFormat('yyyy-MM')) && i.prize_category === 'Monthly Subscriber Prize'  ).map( ( item, index) =>
							<div className="prize" key={index}>
								<div style={{ flex: 'none' }}>
									<div>
										<img src={'//jeff.4zzz.org.au/' + item.field_image.split(',')[0] }  style={{maxWidth: '100%', float: 'left'}} />
									</div>
								</div>
								<div>
									<h3>{item.title}</h3>
									<div dangerouslySetInnerHTML={{ __html: item.prize_winner }}></div>
								</div>
							</div>
						) }
				</div>
			)
		}
		else if ( props.variant === 'list') { 
			return (
				<div className="margin prizes-list">
					{/* <h2>Full Prizes List</h2> */}
	
					{props.prizes.items.filter(i => i.prize_category !== 'Monthly Subscriber Prize').map( ( item, index) =>
							<div className="prize" key={index}>
								<div style={{ flex: 'none' }}>
									<div>
										<img src={'//jeff.4zzz.org.au/' + item.field_image.split(',')[0] }  style={{maxWidth: '100%', float: 'left'}} />
									</div>
								</div>
								<div>
									<h3>{item.title}</h3>
									<div dangerouslySetInnerHTML={{ __html: item.body_1 }}></div>
								</div>
							</div>
						) }
				</div>
			)
		}
		else {
			return (
				<div className="prizes-slider">
					{/* <h2 class="margin">Prizes</h2> */}
	
					<Slider className="prizes-slider" {...settings}>
						{props.prizes.items.filter(i => i.prize_category !== 'Monthly Subscriber Prize').map( ( item, index) =>
							<div key={index}>
								<div className="image-box" style={{ backgroundImage: 'url("//jeff.4zzz.org.au/' + item.field_image.split(',')[0] + '")' }} ></div>
								<h3>{item.title}</h3>
								<div dangerouslySetInnerHTML={{ __html: item.body }}></div>
							</div>
						) }
					</Slider>
				</div>
			)
		}
	}
	else { 
		return null;
	}
	
}

export default connect(state => ({prizes: state.prizes})) (Prizes)
